export default __webpack_public_path__ + "static/media/7.1.fa625700.png";